// extracted by mini-css-extract-plugin
module.exports = {"head":"SystemList_head__2Ol_R","title":"SystemList_title__3KM5r","formwid":"SystemList_formwid__1ut55","tagBox":"SystemList_tagBox__1B3J3","outer":"SystemList_outer__2CyXl"};